import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../services';
import { DIALOG_MODE_IDENTIFIER, IoniconsOutline } from '@pt/pt-models';
import { Observable } from 'rxjs';

@Component({
  selector: 'pt-edit-help',
  template: `
    <div [ngClass]="customClass">
      <ng-container *ngIf="helpValue?.length > 0 && helpValue !== DIALOG_MODE_IDENTIFIER; else NO_DATA">
        <div class="clickable" (click)='configureHelp()'>
          <div class="text-container"
               [innerHTML]="helpValue | removeHelpPrefix">
          </div>
          <div class='btn btn-link btn-sm px-0 ms-auto'>
            <pt-icon [key]='iconUpdate'></pt-icon>
            {{ i18nLabelUpdate | translate }}
            <!--            {{ "BUTTON.UPDATE_HELP" | translate }}-->
          </div>
        </div>
      </ng-container>

      <ng-template #NO_DATA>
        <div class='btn btn-link btn-sm px-0' (click)='configureHelp()'>
          <pt-icon [key]='iconNew'></pt-icon>
          <!--          {{ "BUTTON.CONFIGURE_HELP" | translate }}-->
          {{ i18nLabelNew | translate }}

        </div>

        <span class='text-muted font-italic small'>
          ({{ 'MESSAGE.NODATA' | translate }})
        </span>

      </ng-template>

      <div class="d-flex mt-2" *ngIf='haveResponse && isChanged'>
        <pt-warning
          [message]="'MESSAGE.SAVE_FOR_APPLY' | translate">
        </pt-warning>
      </div>

    </div>
  `,
  styles: [`
    .text-container {
      display: -webkit-box;
      -webkit-line-clamp: 3; /* Limita a 3 righe */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .clickable {
      cursor: pointer;
      opacity: .7;
      /*border: 1px solid #3333333d;*/
      padding: 5px;
    }

    .clickable:hover {
      opacity: 1;
    }
  `]
})
export class EditHelpComponent {

  @Input() i18nLabelNew = 'BUTTON.CONFIGURE_HELP';
  @Input() iconNew: IoniconsOutline = IoniconsOutline.build;
  @Input() i18nLabelUpdate = 'BUTTON.UPDATE_HELP';
  @Input() iconUpdate: IoniconsOutline = IoniconsOutline.build;
  @Input() customClass = 'w-50';
  @Input() enableHtmlMode = true;
  @Input() helpValue?: string;
  @Input() isChanged = false;
  @Output() changeValue = new EventEmitter<string>();
  DIALOG_MODE_IDENTIFIER = DIALOG_MODE_IDENTIFIER;

  haveResponse = false;

  constructor(
    public translateService: TranslateService,
    public dialogService: DialogService
  ) {
  }

  configureHelp() {
    let title: Observable<string>;
    if (this.helpValue?.length > 0 && this.helpValue !== DIALOG_MODE_IDENTIFIER) {
      title = this.translateService.stream(this.i18nLabelUpdate);
    } else {
      title = this.translateService.stream(this.i18nLabelNew);
    }
    this.dialogService.runConfigureHelp(title, this.helpValue, this.enableHtmlMode)
      .subscribe((response: { help: string }) => {
        if (response) {
          this.haveResponse = true;
          this.changeValue.emit(response.help || '');
        }
      });
  }


}
